(function () {
  'use strict';

  var timer = null;

  function cartUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return root + 'cart.js';
  }

  function getSellingPlanId(item) {
    if (!item || !item.selling_plan_allocation) return '';
    var plan = item.selling_plan_allocation.selling_plan || {};
    return String(plan.id || plan.name || 'subscription');
  }

  function signature(cart) {
    return (cart.items || []).map(function (item) {
      return [item.key || item.id, item.quantity, getSellingPlanId(item)].join(':');
    }).join('|');
  }

  function applyTruth(cart) {
    var drawer = document.querySelector('#CartDrawer');
    var inner = drawer && drawer.querySelector('.cart-drawer__inner');
    var bar = drawer && drawer.querySelector('.cart-drawer__body-shipping-bar');
    if (!drawer || !inner || !bar) return;

    var sig = signature(cart);
    if (inner.dataset.idrakShippingTruth === sig) return;
    inner.dataset.idrakShippingTruth = sig;

    var items = cart.items || [];
    var subscriptionItems = items.filter(function (item) { return !!item.selling_plan_allocation; });
    if (!subscriptionItems.length) return;

    var oneTimeItems = items.filter(function (item) { return !item.selling_plan_allocation; });
    var textWrap = bar.querySelector('.cart-drawer__body-shipping-bar-text-wr');
    var success = bar.querySelector('.cart-drawer__body-shipping-bar-text--success');
    var thresholdWrap = bar.querySelector('.cart-drawer__body-shipping-bar-threshold-wr');
    var threshold = bar.querySelector('.cart-drawer__body-shipping-bar-threshold');
    if (!textWrap || !success) return;

    textWrap.setAttribute('data-free-shipping-reached', 'true');

    if (!oneTimeItems.length) {
      success.textContent = 'Free U.S. shipping is included with your subscription.';
      if (thresholdWrap) thresholdWrap.hidden = false;
      if (threshold) threshold.style.width = '100%';
      return;
    }

    success.textContent = 'Subscriptions ship free in the U.S. One-time purchases qualify for free U.S. shipping at $50+.';
    if (thresholdWrap) thresholdWrap.hidden = true;
  }

  function reconcile() {
    fetch(cartUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(applyTruth)
      .catch(function () {
        /* Keep Shopify's server-rendered cart message if cart state cannot be read. */
      });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, 80);
  }

  function init() {
    schedule();
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var observer = new MutationObserver(schedule);
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
